import useTranslation from "../../../../hooks/i18n/useTranslation";
import "../../styles/Settings.css";
import { TextHeader } from "../../components/text-header/TextHeader";
import { ThemeSelector } from "../../components/theme-selector/ThemeSelector";
import { ZoomingSensitivity } from "../../components/zooming-sensitivity/ZoomingSensitivity";

export const Visual = () => {
    const { t } = useTranslation();

    return (
        <div className="settings-container-item settings-container-visual">
            <TextHeader title={t("283")} content={t("284")} />
            <div className="settings-region-content">
                <ThemeSelector />
                <ZoomingSensitivity />
            </div>
        </div>
    )
}